module.exports = __webpack_public_path__ + "static/media/premierOneLeftSeat.c380ee31.svg";